package io.kadbase.studio.shared

fun footerVersionConstant(v: VersionInfo) = "KAD-Base v${v.productVersion}"
